"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1937],{

/***/ 71937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _yema_designkit_webkit_layouts_Section__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46350);




var Title = function(param) {
    var children = param.children, isH1 = param.isH1, className = param.className;
    return isH1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
        className: className,
        children: children
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
        className: className,
        children: children
    });
};
var CMS_BodyTitle = function(param) {
    var content = param.content;
    if (typeof content === "string") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_yema_designkit_webkit_layouts_Section__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: "bg-[#f7f5f1]",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container-fluid",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "rich-text w-full",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: content
                    })
                })
            })
        })
    });
    var title = content.title, is_h1 = content.is_h1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_yema_designkit_webkit_layouts_Section__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: "bg-[#f7f5f1]",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container-fluid",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "rich-text w-full",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                        isH1: is_h1,
                        children: title
                    })
                })
            })
        })
    });
};
CMS_BodyTitle.propTypes = {
    content: prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOfType([
        prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_3__.shape({
            title: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
            is_h1: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool
        }), 
    ]).isRequired
};
/* harmony default export */ __webpack_exports__["default"] = (CMS_BodyTitle);


/***/ })

}]);